import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import RestaurantConfigService from "../services/RestaurantConfigService";

export const RestaurantConfigContext = createContext("RestaurantConfigContext");

const RestaurantConfigContextProvider = ({children}) => {

    const [restaurantConfigList, setRestaurantConfigList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingRestaurantConfigList, setLoadingRestaurantConfigList] = useState(false);

    const getRestaurantConfigList = async id => {
        try {
            setLoadingRestaurantConfigList(true);
            const response = await RestaurantConfigService.getRestaurantConfigList(id);
            setRestaurantConfigList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingRestaurantConfigList(false);
        } catch (error) {
            setLoadingRestaurantConfigList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    return (
        <RestaurantConfigContext.Provider
            value={{
                getRestaurantConfigList,
                restaurantConfigList,
                totalElements,
                loadingRestaurantConfigList,
            }}
        >
            {children}
        </RestaurantConfigContext.Provider>
    );
}

export default RestaurantConfigContextProvider;
